export default __webpack_public_path__ + "static/memberships-stable-visit-icon-e26be95f0caf5ffdfb4d96e0bbf9d887.svg";